// src/Router.jsx
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Layout/Header/Header";
import Footer from "./components/Layout/Footer/Footer";
import AuthGuard from "./components/Guards/GuardAuth";
import { appRoutes } from "./routesConfig";
import ScrollToTop from "./Utilities/Scroll/Scroll";
import NotFound from "./components/Layout/404/NotFound";

const Router = () => (
    <BrowserRouter>
        <ScrollToTop smooth />
        <Header />
        <Routes>
            {appRoutes.map(({ path, element: Element, allowedRoles }, idx) => (
                <Route
                    key={idx}
                    path={path}
                    element={
                        <AuthGuard allowedRoles={allowedRoles}>
                            <Element />
                        </AuthGuard>
                    }
                />
            ))}
            <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
    </BrowserRouter>
);

export default Router;